import Bugsnag from '@bugsnag/js';
import 'bootstrap';
import PreLoaderHandler from "./js/preloader-handler";
import QuerySchedulingAppInputsHandler from "./js/query-scheduling-app-inputs-handler";
import QuerySchedulingAppOutputConfigHandler from "./js/query-scheduling-app-output-config-handler";
import QuerySchedulingAppDataHandler from "./js/query-scheduling-app-data-handler";
import ToastHandler from "./js/toast-handler";
import {errorHandler} from "../main-app/handlers/error-handler/error-handler";
import {clientConfig} from "../main-app/config/client-config";
import WelcomeModal from "./js/welcome-handler/welcome-modal";
import LoadQueryModal from "./js/load-query/load-query-modal";

import "./css/query-scheduling-app-style.scss";

$(document).ready(function (){
    Bugsnag.start({
        apiKey: BUGSNUGAPIKEY,
        appVersion: clientConfig.version
    });
    initDocHeight();
    errorHandler.init([], Bugsnag);
    const toastHandler = new ToastHandler();
    const querySchedulingAppOutputConfigHandler = new QuerySchedulingAppOutputConfigHandler();
    querySchedulingAppOutputConfigHandler.init();
    const querySchedulingAppInputsHandler = new QuerySchedulingAppInputsHandler();
    querySchedulingAppInputsHandler.init();
    const preloaderHandler = new PreLoaderHandler();
    const loadQueryModal = new LoadQueryModal(querySchedulingAppInputsHandler, preloaderHandler, toastHandler);
    new WelcomeModal(querySchedulingAppInputsHandler, loadQueryModal, preloaderHandler).init();
    preloaderHandler.hide();
    const querySchedulingAppDataHandler = new QuerySchedulingAppDataHandler(preloaderHandler, querySchedulingAppInputsHandler, toastHandler);
    querySchedulingAppDataHandler.init();
    loadQueryModal.init();
});

function initDocHeight(){
    function setDocHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
    }
    addEventListener('resize', setDocHeight);
    addEventListener('orientationchange', setDocHeight);
    setDocHeight();
}